export const LOGIN_FETCHING = 'LOGIN_FETCHING';
export const LOGIN_FETCH = 'LOGIN_FETCH';
export const LOGIN_FETCH_ERROR = 'LOGIN_FETCH_ERROR';
export const REGISTER_FETCHING = 'REGISTER_FETCHING';
export const REGISTER_FETCH = 'REGISTER_FETCH';
export const REGISTER_FETCH_ERROR = 'REGISTER_FETCH_ERROR';
export const USER_FETCHING = 'USER_FETCHING';
export const USER_FETCH = 'USER_FETCH';
export const USER_FETCH_ERROR = 'USER_FETCH_ERROR';
export const AMBASSADOR_FETCHING = 'AMBASSADOR_FETCHING';
export const AMBASSADOR_FETCH = 'AMBASSADOR_FETCH';
export const AMBASSADOR_FETCH_ERROR = 'AMBASSADOR_FETCH_ERROR';
export const COMPANY_FETCHING = 'COMPANY_FETCHING';
export const COMPANY_FETCH = 'COMPANY_FETCH';
export const COMPANY_FETCH_ERROR = 'COMPANY_FETCH_ERROR';
export const ACCT_NOTIF_FETCHING = 'ACCT_NOTIF_FETCHING';
export const ACCT_NOTIF_FETCH = 'ACCT_NOTIF_FETCH';
export const ACCT_NOTIF_FETCH_ERROR = 'ACCT_NOTIF_FETCH_ERROR';
export const HYDRATE_MY_ACCT = 'HYDRATE_MY_ACCT';
export const CHANGE_PASSWORD_FETCHING = 'CHANGE_PASSWORD_FETCHING';
export const CHANGE_PASSWORD_FETCH = 'CHANGE_PASSWORD_FETCH';
export const CHANGE_PASSWORD_FETCH_ERROR = 'CHANGE_PASSWORD_FETCH_ERROR';
export const SAVE_AMBASSADOR_FETCHING = 'SAVE_AMBASSADOR_FETCHING';
export const SAVE_AMBASSADOR_FETCH = 'SAVE_AMBASSADOR_FETCH';
export const SAVE_AMBASSADOR_FETCH_ERROR = 'SAVE_AMBASSADOR_FETCH_ERROR';
export const SAVE_NOTIFICATIONS_FETCHING = 'SAVE_NOTIFICATIONS_FETCHING';
export const SAVE_NOTIFICATIONS_FETCH = 'SAVE_NOTIFICATIONS_FETCH';
export const SAVE_NOTIFICATIONS_FETCH_ERROR = 'SAVE_NOTIFICATIONS_FETCH_ERROR';
export const UNSUBSCRIBE_FETCHING = 'UNSUBSCRIBE_FETCHING';
export const UNSUBSCRIBE_FETCH = 'UNSUBSCRIBE_FETCH';
export const UNSUBSCRIBE_FETCH_ERROR = 'UNSUBSCRIBE_FETCH_ERROR';
export const DEACTIVATE_ACCOUNT_FETCHING = 'DEACTIVATE_ACCOUNT_FETCHING';
export const DEACTIVATE_ACCOUNT_FETCH = 'DEACTIVATE_ACCOUNT_FETCH';
export const DEACTIVATE_ACCOUNT_FETCH_ERROR = 'DEACTIVATE_ACCOUNT_FETCH_ERROR';
export const ACTIVATE_ACCOUNT_FETCHING = 'ACTIVATE_ACCOUNT_FETCHING';
export const ACTIVATE_ACCOUNT_FETCH = 'ACTIVATE_ACCOUNT_FETCH';
export const ACTIVATE_ACCOUNT_FETCH_ERROR = 'ACTIVATE_ACCOUNT_FETCH_ERROR';
export const RESET_LOGIN_STATUS = 'RESET_LOGIN_STATUS';
export const USER_SSO_FETCH = 'USER_SSO_FETCH';
export const USER_SSO_FETCH_ERROR = 'USER_SSO_FETCH_ERROR';
export const FORGOT_PASSWORD_FETCHING = 'FORGOT_PASSWORD_FETCHING';
export const FORGOT_PASSWORD_FETCH = 'FORGOT_PASSWORD_FETCH';
export const FORGOT_PASSWORD_FETCH_ERROR = 'FORGOT_PASSWORD_FETCH_ERROR';
export const FORGOT_PASSWORD_CLEAN = 'FORGOT_PASSWORD_CLEAN';
export const LOGOUT = 'LOGOUT';
export const ACTIVITY_FETCHING = 'ACTIVITY_FETCHING';
export const ACTIVITY_FETCH = 'ACTIVITY_FETCH';
export const ACTIVITY_FETCH_ERROR = 'ACTIVITY_FETCH_ERROR';
export const RESET_PASSWORD_FETCHING = 'RESET_PASSWORD_FETCHING';
export const RESET_PASSWORD_FETCH = 'RESET_PASSWORD_FETCH';
export const RESET_PASSWORD_FETCH_ERROR = 'RESET_PASSWORD_FETCH_ERROR';
export const SET_PORTAL_CHANNEL = 'SET_PORTAL_CHANNEL';
